import React from 'react';
import PropTypes from 'prop-types';
import TextWithDefinition from '../../TextWithDefinition';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
	header: {
		flexDirection: 'row',
		display: 'inline-block',
		fontSize: '14px !important',
		fontWeight: '700 !important',
		textWrap: 'auto',
		paddingRight: '16px !important',
		paddingLeft: '16px !important',
		fontFamily: 'Bogle-Regular !important',
		maxWidth: '165px  !important',
		textOverflow: 'ellipsis !important',
		overflow: 'hidden  !important',
		whiteSpace: 'nowrap  !important'
	},
}));
const CustomColumnMainHeader = (props) => {
	const classes = useStyles();
	return (
		<div role="none">
			<TextWithDefinition
				id={'header'}
				text={props.displayName}
				classStyle={classes.header}
				definitionId={props.definitionId}
				hasDefinition={props.hasDefinition}
			/>
		</div>
	);
};

CustomColumnMainHeader.propTypes = {
	displayName: PropTypes.string,
	hasDefinition: PropTypes.bool,
	definitionId: PropTypes.string,
};

export default CustomColumnMainHeader;
